import excelJS from 'exceljs'
import { save } from 'save-file'
import applyDefaultWorkbookView from '/utils/excel-workbook-view'
import moment from 'moment-timezone'
import { getVisibleExportColumns } from '/utils/export-data'

const columns = [
  { name: "Timestamp", item: "timestamp", width: 50, format: "date" },
  { name: "Action", item: "action", width: 50 },
  { name: "Error", item: "error", width: 50 },
  { name: "Points Added", item: "points_added", width: 50 },
  { name: "Points Redeemed", item: "points_redeemed", width: 50 },
  { name: "Reference", item: "reference", width: 50 },
  { name: "Adjusted by admin", item: "admin", width: 50 },
  { name: "Note", item: "note", width: 50 },
  { name: "Handled By", item: "username", width: 50 },
  { name: "Scan Location", item: "position", width: 50, format: "location" },
]

const giftCardHistory = async ({ fileName, data, visibleColumns }) => {
  const exportColumns = getVisibleExportColumns(columns, visibleColumns)

  const workbook = new excelJS.Workbook()

  workbook.views = [
    {
      x: 0, y: 0, width: 3, height: 1000,
      firstSheet: 0, activeTab: 1, visibility: 'visible'
    }
  ]

  const font = { name: 'Courier', size: 12, bold: true }

  const passes_worksheet = workbook.addWorksheet("scans")

  exportColumns.map((col, idx) => passes_worksheet.getColumn(idx + 1).width = col.width)

  const passes_row = passes_worksheet.getRow(1)

  exportColumns.map((col, idx) => passes_row.getCell(idx + 1).value = col.name)

  exportColumns.map((col, idx) => passes_row.getCell(idx + 1).font = font)

  data.map((r, i) => {
    const row = passes_worksheet.getRow(i + 2)

    exportColumns.map((col, idx) => row.getCell(idx + 1).value = col.format ? formatDataItem(r, col) : r[col.item])
    exportColumns.map((col, idx) => row.getCell(idx + 1).font = font)
  })


  applyDefaultWorkbookView(workbook)
  const buffer = await workbook.xlsx.writeBuffer()

  await save(buffer, fileName + '.xlsx')
}

export default giftCardHistory

const formatDataItem = (row, col) => {

  const value = row[col.item]

  switch (col.format) {
    case "date": return value ? moment(value, "YYYYMMDDHHmmSS").format("YYYY-MM-DD HH:mm") : ""
    case "yes": return value === 1 ? "yes" : ""
    case "location": return value ? `${value.x},${value.y}` : ""
  }
}
